import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CloseButton } from 'secondstep-components'
import {
  DeleteCheckBox,
  DeleteMessageWrapper,
  StyledButtonsWrapper,
} from '../Delete/component.styles'
import { CancelButton, ModalHeaderInput } from '../../component.styles'
import {
  ClassCardModalWrapperLeave,
  LeaveButton,
  ModalWrapperLeave,
} from './component.styles'
import {
  LEAVE_CANCEL,
  LEAVE_CONFIRM,
  LEAVE_HEADER,
  LEAVE_NOTICE,
  LEAVE_SUBMIT,
} from './constants'

const LeaveClass = ({
  courseInstanceName,
  dataTestId,
  handleCancel,
  handleSubmit,
  isClassCardMenu,
}) => {
  const [isDisabled, setIsDisabled] = useState(true)

  const LeaveModal = isClassCardMenu
    ? ClassCardModalWrapperLeave
    : ModalWrapperLeave

  return (
    <LeaveModal dataTestId={dataTestId} isClassCardMenu={isClassCardMenu}>
      <CloseButton dataTestId="button-close" onClick={handleCancel} />
      <ModalHeaderInput dataTestId="modal-leave-header">
        {LEAVE_HEADER(courseInstanceName)}
      </ModalHeaderInput>
      <DeleteMessageWrapper>
        <span>{LEAVE_NOTICE}</span>
      </DeleteMessageWrapper>
      <DeleteCheckBox
        dataTestId="leave-input"
        onChange={() => setIsDisabled(!isDisabled)}
        options={[LEAVE_CONFIRM]}
        selected={{}}
      />
      <StyledButtonsWrapper>
        <CancelButton dataTestId="button-cancel" onClick={handleCancel}>
          {LEAVE_CANCEL}
        </CancelButton>
        <LeaveButton
          dataTestId="button-leave-class"
          disabled={isDisabled}
          isDisabled={isDisabled}
          onClick={handleSubmit}
        >
          {LEAVE_SUBMIT}
        </LeaveButton>
      </StyledButtonsWrapper>
    </LeaveModal>
  )
}

LeaveClass.propTypes = {
  courseInstanceName: PropTypes.string,
  dataTestId: PropTypes.string,
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  isClassCardMenu: PropTypes.bool,
}

export default LeaveClass
